"use strict";

var debug = require("debug")("knack.formatter.formatters.link");

/**
 * @alias "formatters.link"
 * @param {Object} value
 * @param {String} value.url
 * @param {Object} [linkFormat]
 * @param {String} [linkFormat.label] Label of anchor tag
 * @param {String} [linkFormat.text_format] 'same' = linkFormat.label, 'unique' = linkFormat.label or value.url, anything else = value.url
 * @param {String} [linkFormat.target] Anchor tag 'target' parameter, if not '_blank', it is *not* added
 * @param {String} [responseFormat] if `responseFormat` == 'text', return value.url
 * @return {String}
 */
var linkFormatter = function linkFormatter(value, linkFormat, responseFormat) {
  if (!value || !value.url) {
    return "";
  }
  if (responseFormat === "text") {
    return value.url;
  }
  linkFormat = linkFormat || {
    text_format: "url",
    target: "_blank"
  };

  // make sure there is a scheme at the start of the URI, otherwise assume it is http for the href
  var link = "<a href=\"".concat(/^\w+:\/\//.test(value.url) ? value.url : "http://".concat(value.url), "\"");
  if (linkFormat.target === "_blank") {
    link += " target=\"_blank\"";
  }
  link += ">";
  switch (linkFormat.text_format) {
    case "same":
      link += linkFormat.label;
      break;
    case "unique":
      link += value.label ? value.label : value.url;
      break;
    default:
      link += value.url;
      break;
  }
  link += "</a>";
  return link;
};
module.exports = linkFormatter;